/* eslint-disable max-lines */
import React, {
    useEffect, useState
} from 'react';
import {
    Button
} from 'shared/components/ui/button';
import {
    Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle
} from 'shared/components/ui/dialog';
import {
    Label
} from 'shared/components/ui/label';
import InputValidation from 'shared/components/InputValidation';
import {
    Textarea
} from 'shared/components/ui/textarea';
import {
    AlertCircle
} from 'lucide-react';
import labHelper from 'builders/builderInternal/classes/AILabHelper';

function SaveOrUpdateInstruction({
    isOpen, onClose, onSaveOrUpdate, loading, loadedInstruction, isUpdate, isFormValid = true, onValidationError
}) {
    const [uniqueName, setUniqueName] = useState('');
    const [modelDescription, setModelDescription] = useState('');

    useEffect(() => {
        if (loadedInstruction && isUpdate) {
            setUniqueName(loadedInstruction.unique_name);
            setModelDescription(loadedInstruction.modelDescription);
        } else {
            setUniqueName('');
            setModelDescription('');
        }
    }, [isOpen, isUpdate, loadedInstruction]);

    const handleSaveOrUpdate = async () => {
        // Validate form before saving/updating
        if (!isFormValid) {
            if (onValidationError) {
                onValidationError();
            }
            return;
        }

        await onSaveOrUpdate(uniqueName, modelDescription, isUpdate);
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[600px] select-none">
                <DialogHeader>
                    <DialogTitle>
                        {
                            loadedInstruction && isUpdate ? 'Update Instruction'
                                : loadedInstruction && !isUpdate ? 'Copy instruction'
                                    : 'Save Instruction'
                        }
                    </DialogTitle>
                    <DialogDescription>
                        Please make sure that you have experimented with your instruction and are satisfied with the output it is giving.
                    </DialogDescription>
                </DialogHeader>
                {!isFormValid && (
                    <div className="flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900">
                        <AlertCircle className="h-4 w-4" />
                        <span>Instruction must contain a prompt before it can be saved or updated.</span>
                    </div>
                )}
                <div className="grid gap-4 py-4">
                    <div className="grid grid-cols-4 items-center gap-4">
                        <Label htmlFor="name" className="text-right">
                            Unique Name
                        </Label>
                        <InputValidation
                            id="name"
                            value={uniqueName}
                            onChange={(e) => setUniqueName(e.target.value)}
                            className="col-span-3"
                            placeholder="Enter a unique name for your instruction"
                            disabled={isUpdate}
                            validation={labHelper.validateUniqueName}
                        />
                    </div>
                    <div className="grid grid-cols-4 items-center gap-4">
                        <Label htmlFor="description" className="text-right">
                            Description
                        </Label>
                        <Textarea
                            id="description"
                            value={modelDescription}
                            onChange={(e) => setModelDescription(e.target.value)}
                            className="col-span-3"
                            placeholder="Enter description for your instruction"
                        />
                    </div>
                </div>
                <div className="modal-actions flex flex-row gap-2 items-center justify-end">
                    <Button variant="outline" onClick={onClose}>Cancel</Button>
                    <Button
                        className='px-2 w-fit min-w-[70px]'
                        size='icon'
                        variant="default"
                        disabled={loading || labHelper.validateUniqueName(uniqueName).isValid === false || !isFormValid}
                        onClick={handleSaveOrUpdate}>
                        {loading ? (isUpdate ? 'Updating instruction...' : 'Saving instruction...') : (isUpdate ? 'Update' : 'Save')}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default SaveOrUpdateInstruction;